module.exports = __webpack_public_path__ + "img/GAME_COLORPAPER.26296108.png";